<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 64 32" width="48" height="24">
        <!-- main body - rounded van shape -->
        <path d="M 4 22 L 4 10 Q 4 6, 8 6 L 50 6 Q 54 6, 56 10 L 58 14 L 58 22 Z" fill="#e8e8e8"/>
        <!-- roof line -->
        <path d="M 8 6 Q 4 6, 4 10 L 4 8 Q 4 5, 8 5 L 50 5 Q 53 5, 55 8 L 54 10 Q 54 7, 50 6 L 8 6" fill="#d0d0d0"/>
        <!-- front windshield (angled) -->
        <path d="M 50 6 Q 54 6, 56 10 L 56 16 L 50 16 L 50 6" fill="#87ceeb"/>
        <!-- front passenger window -->
        <rect x="42" y="8" width="7" height="8" rx="1" fill="#87ceeb"/>
        <!-- sliding door track line -->
        <line x1="40" y1="6" x2="40" y2="22" stroke="#ccc" stroke-width="0.5"/>
        <!-- sliding door window -->
        <rect x="26" y="8" width="12" height="8" rx="1" fill="#87ceeb"/>
        <!-- sliding door handle -->
        <rect x="36" y="14" width="2" height="1" fill="#666"/>
        <!-- rear cargo area (no window or small window) -->
        <rect x="6" y="8" width="8" height="6" rx="1" fill="#87ceeb"/>
        <!-- body line detail -->
        <line x1="4" y1="18" x2="58" y2="18" stroke="#ccc" stroke-width="0.5"/>
        <!-- front door seam -->
        <line x1="40" y1="6" x2="40" y2="22" stroke="#bbb" stroke-width="0.5"/>
        <!-- wheels -->
        <circle cx="14" cy="24" r="5" fill="#222"/>
        <circle cx="14" cy="24" r="3" fill="#444"/>
        <circle cx="14" cy="24" r="1" fill="#666"/>
        <circle cx="48" cy="24" r="5" fill="#222"/>
        <circle cx="48" cy="24" r="3" fill="#444"/>
        <circle cx="48" cy="24" r="1" fill="#666"/>
        <!-- headlight -->
        <rect x="56" y="15" width="2" height="3" rx="1" fill="#ffdd00"/>
        <!-- taillight -->
        <rect x="4" y="15" width="2" height="3" rx="1" fill="#cc0000"/>
        <!-- side mirror -->
        <rect x="56" y="10" width="3" height="2" rx="0.5" fill="#333"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VanAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
